<bic-popup (close)="onClose()" [hasBackdrop]="true" customClass="w-[760px]" title="myCheck erstellen">
  <div bicPopupContent class="flex flex-col gap-6">
    <bic-input (keyup.enter)="name.trim() && onCreate()" [(ngModel)]="name" [label]="'Name'"
               [placeholder]="'z. B. Brandschutz Check'" [showX]="false"></bic-input>

    <!-- Mit Quickstart entfällt die Typwahl: der Agent entscheidet im Interview selbst zwischen
         KI-Prüfung (Dokumente) und IDS-Prüfung (IFC-Modell) und legt den myCheck danach an. -->
    @if (!quickstartActive) {
      <bic-select [(ngModel)]="type" [label]="'Typ myCheck'" [placeholder]="'Typ auswählen...'">
        @for (opt of typeOptions; track opt.value) {
          <bic-dropdown-element [value]="opt.value">{{ opt.label }}</bic-dropdown-element>
        }
      </bic-select>
    }

    @if (showTemplates) {
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1 overflow-clip pb-1 pt-2">
          <span class="text-[11px] uppercase text-gray-400 font-medium">ODER MIT EINER VORLAGE STARTEN</span>
          <div class="h-px w-full bg-gray-200"></div>
        </div>
        <div class="grid grid-cols-2 gap-4">
          @for (template of templates; track template.name) {
            <button
              (click)="selectTemplate(template)"
              class="flex items-center gap-3 rounded-lg border border-gray-200 px-3 py-2 text-left transition hover:border-gray-400"
              type="button">
              <span class="flex h-6 w-6 items-center justify-center text-gray-500">
                <fa-icon [icon]="template.icon" class="text-sm"></fa-icon>
              </span>
              <span class="flex flex-col text-gray-900 min-w-0">
                <span class="text-sm font-medium leading-normal">{{ template.name }}</span>
                <span class="text-xs leading-normal line-clamp-1">{{ template.description }}</span>
              </span>
            </button>
          }
        </div>
      </div>
    }
  </div>

  <div bicPopupButtonGroup class="flex flex-row w-full justify-between items-center gap-6">
    <div class="flex flex-col gap-0.5">
      <!-- Der Tooltip hängt am Wrapper, weil ein deaktivierter Toggle keine Maus-Events bekommt. -->
      <div class="flex items-center gap-2" [class.cursor-not-allowed]="chatQuotaExceeded"
           [tooltip]="quickstartDisabledTooltip" tooltipDirection="top">
        <bic-toggle
          (ngModelChange)="onQuickstartModeChange($event)"
          [ngModel]="quickstartActive"
          [disabled]="chatQuotaExceeded"></bic-toggle>
        <span class="text-sm" [class.text-gray-900]="!chatQuotaExceeded"
              [class.text-gray-400]="chatQuotaExceeded">Quickstart</span>
      </div>
      <span class="text-xs text-gray-500">
        {{
          chatQuotaExceeded
            ? 'chatBIC-Kontingent aufgebraucht – der myCheck wird leer im Editor geöffnet.'
            : startInQuickstartMode
              ? 'chatBIC klärt im Gespräch, ob Dokumente oder das IFC-Modell geprüft werden, und baut den myCheck.'
              : 'Der myCheck wird leer im Editor geöffnet.'
        }}
      </span>
    </div>
    <div class="flex flex-row items-center gap-4">
      <bic-button (onClick)="onClose()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="onCreate()" [disabled]="!name.trim()">Erstellen</bic-button>
    </div>
  </div>
</bic-popup>
